import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, MessageCircle } from "lucide-react";
import { SITE, waUrl } from "../lib/site";

const links = [
  { to: "/", label: "Home" },
  { to: "/criacao-de-sites", label: "Criação de Sites" },
  { to: "/site-profissional", label: "Sites Rápidos" },
  { to: "/google-ads", label: "Google Ads" },
  { to: "/meta-ads", label: "Meta Ads" },
  { to: "/avaliacoes", label: "Avaliações" },
  { to: "/contato", label: "Contato" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 w-full backdrop-blur-xl transition-all ${
        scrolled
          ? "bg-[#000000]/95 border-b border-white/10"
          : "bg-[#000000] border-b border-transparent"
      }`}
    >
      <div className="g-stripe g-stripe-thin" />
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex items-center justify-between h-20">
        <Link
          to="/"
          data-testid="header-logo-link"
          className="flex items-center"
        >
          <img
            src={SITE.logo}
            alt="O.G. Digital"
            className="h-14 w-auto object-contain"
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-").replace(/ç/g, "c").replace(/ã/g, "a").replace(/õ/g, "o")}`}
              className={({ isActive }) =>
                `px-4 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? "text-white"
                    : "text-white/60 hover:text-white"
                }`
              }
            >
              {({ isActive }) => (
                <span className="relative inline-block">
                  {l.label}
                  {isActive && (
                    <span
                      className="absolute -bottom-1 left-0 right-0 h-[2px]"
                      style={{
                        background:
                          "linear-gradient(to right,#4285F4 0%,#4285F4 25%,#EA4335 25%,#EA4335 50%,#FBBC05 50%,#FBBC05 75%,#34A853 75%,#34A853 100%)",
                      }}
                    />
                  )}
                </span>
              )}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={waUrl()}
            target="_blank"
            rel="noreferrer"
            data-testid="header-whatsapp-cta"
            className="hidden md:inline-flex btn-whatsapp text-sm"
            style={{ padding: "10px 18px" }}
          >
            <MessageCircle size={16} />
            WhatsApp
          </a>
          <button
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            className="lg:hidden p-2 text-white"
            aria-label="Abrir menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden border-t border-gray-100 bg-white"
        >
          <nav className="flex flex-col py-4 px-6">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `py-3 text-base font-medium border-b border-gray-100 last:border-b-0 ${
                    isActive ? "text-[#000000]" : "text-[#000000]/70"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <a
              href={waUrl()}
              target="_blank"
              rel="noreferrer"
              data-testid="mobile-whatsapp-cta"
              className="btn-whatsapp mt-4 justify-center"
            >
              <MessageCircle size={18} />
              Falar no WhatsApp
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
